import type { ImageGenerationErrorResponse } from '../shared/types';

export type ImageErrorPanel = {
  title: string;
  message: string;
  suggestion: string;
  requestId: string;
};

function isImageErrorResponse(value: unknown): value is ImageGenerationErrorResponse {
  if (!value || typeof value !== 'object') return false;
  const candidate = value as Partial<ImageGenerationErrorResponse>;
  return typeof candidate.error === 'string'
    && typeof candidate.code === 'string'
    && typeof candidate.message === 'string'
    && typeof candidate.suggestion === 'string'
    && typeof candidate.requestId === 'string';
}

export function toImageErrorResponse(error: unknown): ImageGenerationErrorResponse {
  if (isImageErrorResponse(error)) return error;
  const message = error instanceof Error ? error.message : '图片服务没有返回明确的失败原因。';
  return {
    error: '图片生成失败',
    code: 'PROVIDER_ERROR',
    message,
    suggestion: '检查画面提示词和参考图后重试；如果仍然失败，请保留请求编号并联系管理员。',
    requestId: '未提供',
    retryable: true,
  };
}

export function toImageErrorPanel(error: unknown): ImageErrorPanel {
  const response = toImageErrorResponse(error);
  return {
    title: response.error,
    message: response.message,
    suggestion: response.suggestion,
    requestId: response.requestId,
  };
}
